<template>
    <div>
      <div v-if="excludeTerms.length">
        {{ `${excludeTerms.length || 0} words excluded` }}
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        {{ `${excludeTerms.length || 0} words excluded` }}
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewExcludeTerms',
    props: [
        'excludeTerms',
    ],
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>